import { forwardRef } from 'react';

/**
 * The full Etch wordmark (spec §5.1, §7.2): "ETCH" with the trailing dot
 * carried as a red square (`.etch-wordmark__dot`, styled in typography.css).
 * Used in setup, login, marketing transitions and the expanded desktop nav.
 *
 * The visible glyph is set `aria-hidden` and the accessible name is fixed to
 * `aria-label="Etch"` instead of letting it fall out of the DOM text: modern
 * browsers factor CSS `text-transform` into the computed accessible name, so
 * an all-caps node risks being announced letter-by-letter ("E, T, C, H")
 * rather than as the word "Etch". `Etch` is the brand name and per spec §13
 * is never translated, so this is not an i18n prop.
 *
 * @param {object} props
 * @param {'sm'|'md'|'lg'} [props.size='md']
 * @param {'default'|'inverse'} [props.tone='default']
 * @param {import('react').ElementType} [props.as='span'] - render as e.g. `RouterLink`.
 * @param {string} [props.className]
 */
export const Wordmark = forwardRef(function Wordmark(
  { size = 'md', tone = 'default', as: Component = 'span', className = '', ...rest },
  ref
) {
  return (
    <Component
      ref={ref}
      className={`etch-wordmark ${className}`.trim()}
      data-size={size === 'md' ? undefined : size}
      data-tone={tone === 'default' ? undefined : tone}
      aria-label="Etch"
      {...rest}
    >
      <span aria-hidden="true">
        ETCH
        <span className="etch-wordmark__dot" aria-hidden="true" />
      </span>
    </Component>
  );
});

export default Wordmark;
